<template>
  <div class="appResponsiveHeight">
    <v-app id="inspire" :class="hideContainer ? 'register-container' : 'wrapper'">
      <v-app-bar app elevate-on-scroll elevation="0" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'"
        class="custom-navbar" v-if="!$route.meta.noSidebar">
        <v-container class="fill-height app-bar-container">
          <v-app-bar-nav-icon class="d-md-none d-sm-flex d-xl-none d-lg-none"
            @click="drawer = !drawer"></v-app-bar-nav-icon>
          <DashboardView></DashboardView>
          <audio id="notification-bell" src="../public/sounds/notification-bell.wav" preload="auto"></audio>
          <v-spacer></v-spacer>
          <ul class="top-links-list">
            <li>
              <v-tooltip bottom content-class="tooltip-dark">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn fab link small to="/internal-transfer" :ripple="false" elevation="0" v-bind="attrs" v-on="on"
                    :color="$vuetify.theme.dark ? '#1A2A3E' : '#F8F6FC'">
                    <v-icon color="#039de9">mdi-swap-horizontal</v-icon>
                  </v-btn>
                </template>
                <span class="tooltip-text">Internal Transfer</span>
              </v-tooltip>
            </li>
            <li>
              <v-tooltip bottom content-class="tooltip-dark">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn fab link small to="/withdraw" :ripple="false" elevation="0" v-bind="attrs" v-on="on"
                    :color="$vuetify.theme.dark ? '#1A2A3E' : '#F8F6FC'">
                    <v-icon color="#039de9">mdi-tray-arrow-up</v-icon>
                  </v-btn>
                </template>
                <span class="tooltip-text">Withdraw</span>
              </v-tooltip>
            </li>
            <li>
              <v-tooltip bottom content-class="tooltip-dark">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn fab link small to="/deposit" :ripple="false" elevation="0" v-bind="attrs" v-on="on"
                    :color="$vuetify.theme.dark ? '#1A2A3E' : '#F8F6FC'">
                    <v-icon color="#039de9">mdi-tray-arrow-down</v-icon>
                  </v-btn>
                </template>
                <span class="tooltip-text">Deposit</span>
              </v-tooltip>
            </li>
            <!-- <li v-if="client?.is_tutorial == 1 && tutorial_link">
              <a fab link small :href="tutorial_link || '#'" target="_blank" elevation="0"
                :color="$vuetify.theme.dark ? '#1A2A3E' : '#F8F6FC'">
                <v-icon color="#FF0033">mdi-youtube</v-icon>
                <span class="tutorial-text text--primary">Tutorial</span>
              </a>
            </li> -->
          </ul>
          <PanelSwitcherView v-if="hasIbStatus"></PanelSwitcherView>
          <SwitcherView></SwitcherView>
          <NotificationView></NotificationView>
          <LogoutView></LogoutView>
        </v-container>
      </v-app-bar>
      <div :class="hideContainer ? 'container-fluid' : 'custom-container'">
        <v-row no-gutters>
          <v-col xl="2" class="custom-width-navigation-drawer" v-if="!$route.meta.noSidebar">
            <div class="navigation-drawer-container">
              <v-navigation-drawer v-model="drawer" :permanent="$vuetify.breakpoint.mdAndUp" width="240"
                class="navigation-drawer sidebar-navigation-drawer"
                :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
                <AdminLogo></AdminLogo>
                <AllMenu></AllMenu>
              </v-navigation-drawer>
            </div>
          </v-col>
          <v-col class="custom-width-main registration-page">
            <v-main>
              <router-view></router-view>
              <!--WhatsApp Floating Button -->
              <!-- <a href="https://wa.me/971525622077?text=Hello%20I%20need%20help" target="_blank" class="whatsapp-btn"
                title="Chat on WhatsApp">
                <v-icon color="white" size="28">mdi-whatsapp</v-icon>
              </a> -->
            </v-main>
          </v-col>
        </v-row>
      </div>
    </v-app>
  </div>
</template>

<script>
import AdminLogo from "./components/SideBar/AdminLogo.vue";
import AllMenu from "./components/SideBar/AllMenu.vue";
import DashboardView from "./components/TopBar/DashboardView.vue";
import LogoutView from "./components/TopBar/LogoutView.vue";
import NotificationView from "./components/TopBar/NotificationView.vue";
import PanelSwitcherView from "./components/TopBar/PanelSwitcherView.vue";
import SwitcherView from "./components/TopBar/SwitcherView.vue";
import { mapActions, mapState } from "vuex";
import { PROFILE__ACTIONS } from "@/store/action-types";

export default {
  data() {
    return {
      drawer: null,
      is_tutorial: true,
    };
  },

  components: {
    NotificationView,
    SwitcherView,
    DashboardView,
    LogoutView,
    AdminLogo,
    AllMenu,
    PanelSwitcherView
  },

  watch: {
    client: {
      handler(val) {
        if (val && val.theme_preference !== undefined) {
          this.$vuetify.theme.dark = val.theme_preference === 1;
        }
      },
      immediate: true,
    },
  },

  computed: {
    ...mapState("profile", ["client", "tutorials"]),

    tutorial_link() {
      if (Array.isArray(this.tutorials) && this.tutorials.length > 0) {
        // Get the full current route including query params
        const fullPath = this.$route.fullPath;

        // Split the fullPath into path and query string
        const [path, query] = fullPath.split('?');

        // Convert the path to kebab-case and keep the query string intact
        const currentRoute = path
          .replace(/[^a-zA-Z0-9\s-]/g, "")  // Remove special characters except for hyphens
          .trim()  // Remove leading/trailing spaces
          .replace(/\s+/g, "-")  // Replace multiple spaces with a single hyphen
          .toLowerCase();  // Ensure the case is consistent

        // Rebuild the full route with the query string
        const finalRoute = query ? `${currentRoute}?${query}` : currentRoute;

        // Remove the "client=" prefix from info_link if it exists
        const matchedTutorial = this.tutorials.find(tutorial => {
          const infoLink = tutorial.route.replace('client=', '');  // Remove "client=" from the info_link
          return infoLink === finalRoute;
        });

        return matchedTutorial ? matchedTutorial.info_link : null;
      }
      return null;
    },

    hideContainer() {
      return (
        this.$route.name === "/" ||
        this.$route.name === "Login" ||
        this.$route.name === "CreateAccount" ||
        this.$route.name === "Registration" ||
        this.$route.name === "SendOtp" ||
        this.$route.name === "ForgotPassword"
      );
    },

    hasIbStatus() {
      return this.$store.state.authentication.ib_status === 1;
    }
  },

  methods: {
    ...mapActions("profile", ["GETPROFILE", "GETTUTORIALS"]),
  },

  async created() {
    await this[PROFILE__ACTIONS.GETPROFILE]();
    await this[PROFILE__ACTIONS.GETTUTORIALS]();
  },
};
</script>

<style scoped>
.appResponsiveHeight {
  height: 100vh;
  overflow-y: hidden;
  overflow-x: hidden;
}

/* ✅ Floating WhatsApp button fixed to bottom-right */
.whatsapp-btn {
  position: fixed !important;
  bottom: 50px !important;
  right: 35px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 55px;
  height: 55px;
  background-color: #25d366;
  border-radius: 50%;
  text-decoration: none;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
  transition: all 0.3s ease;
  z-index: 9999;
  /* ensures it stays above everything */
}

.whatsapp-btn:hover {
  background-color: #1ebe5d;
  transform: scale(1.1);
}

.tutorial-text {
  margin-left: 10px;
  text-decoration: underline;
  opacity: .9;
  font-weight: 300;
  font-size: 14px;
}
</style>